import { UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  SystemTemplatePreviewPayload,
  SystemTemplatePreviewResponse,
} from 'models/automation/SystemTemplates';
import API from 'services/API';

type UseSystemTemplatePreviewMutationArgs = SystemTemplatePreviewPayload;

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    AxiosResponse<SystemTemplatePreviewResponse>,
    BaseErrorResponse,
    UseSystemTemplatePreviewMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const previewSystemTemplate = ({
  ...payload
}: UseSystemTemplatePreviewMutationArgs) => {
  return API.post<
    SystemTemplatePreviewResponse,
    AxiosResponse<SystemTemplatePreviewResponse>
  >(`/api/internal/automation/system-templates/preview`, payload);
};

const useSystemTemplatePreviewMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: previewSystemTemplate,
    ...options,
  });
};

export default useSystemTemplatePreviewMutation;
